<div class="mat-dialog-header">
  <div class="mat-dialog-title">
    {{isCreating ? "Create Event Category" : "Edit Event Category"}}

  </div>
  <fa-icon (click)="dialogRef.close()" [icon]="['fas', 'close']"></fa-icon>
</div>
<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<div mat-dialog-content>
  <mat-form-field >
    <mat-label>Name</mat-label>
    <input
      matInput
      [formControl]="nameControl"
      placeholder="Name"/>
  </mat-form-field>

  <div class="modal-action-row">
    <button
      type="button"
      mat-button
      class="modal-cancel-button"
      (click)="dialogRef.close();">
      Cancel
    </button>
    <button
      [disabled]="!this.nameControl.value"
      type="submit"
      mat-button
      class="modal-submit-button"
      (click)="submit()">
      {{isCreating ? 'Create' : 'Update'}}
    </button>
  </div>
</div>
